import { z } from 'zod'

export const CoordinatesSchema = z.object({
  latitude: z.coerce.number().min(-90).max(90),
  longitude: z.coerce.number().min(-180).max(180),
})

export type Coordinates = z.infer<typeof CoordinatesSchema>
